import { container } from '@graphistry/falcor-react-redux';
import { Logo as LogoComponent } from '@graphistry/viz/src/components/logo';

const Logo = container({
    renderLoading: true,
    fragment: (logo = {}) => {
        return `{
            url, autoInvert, position,
            dimensions: { maxWidth, maxHeight },
            crop: { top, left, bottom, right },
            padding: { top, left, bottom, right },
            style: { brightness, contrast, grayscale, hueRotate, opacity, saturate }
        }`;
    },
    mapFragment: (fragment, props, $falcor) => {
        return ({ $falcor, ...fragment, ...props });
    }
})(LogoComponent);

export { Logo };
